import { useContext, useEffect } from "react";
import EventList from "../Components/EventList";
import { CartContext } from "../context/CartContext";
import HeroCarousel from "../Components/HeroCarrousel";
import eventService from "../services/eventService";
import { useState } from "react";
import EventSearchInput from "../Components/EventSerachInput";

const Events = () => {
    const { cleanCart } = useContext(CartContext);
    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [query, setQuery] = useState("");

    useEffect(() => {
        const fetchEvents = async () => {
            try {
                const eventsData = await eventService.getAllEvents(query);
                setEvents(eventsData);
                setLoading(false);
            } catch (err) {
                setError("Error al cargar los eventos");
                setLoading(false);
            }
        };

        fetchEvents();
    }, [query]);

    const handleSearch = (e) => {
        e.preventDefault();
        setQuery(query.trim());
    };

    useEffect(() => {
        cleanCart();
    }, []);

    const hasHero = events.length > 0;

    return (
        <div className="relative min-h-screen overflow-hidden bg-zinc-950">
            <div
                className="pointer-events-none absolute inset-0 opacity-70"
                aria-hidden="true"
                style={{
                    background:
                        "radial-gradient(circle at 15% 20%, rgba(253, 191, 4, 0.20), transparent 34%), radial-gradient(circle at 85% 15%, rgba(234, 179, 8, 0.14), transparent 28%), radial-gradient(circle at 50% 85%, rgba(250, 204, 21, 0.10), transparent 36%)",
                }}
            />
            <div className="relative">{hasHero && <HeroCarousel events={events} />}</div>
            <div
                className={`relative mx-auto max-w-6xl px-3 pb-8 sm:px-4 lg:px-0 ${
                    hasHero ? "" : "pt-20 md:pt-24"
                }`}
            >
                <EventSearchInput
                    query={query}
                    setQuery={setQuery}
                    onSearch={handleSearch}
                />
                <div className="ml-2 mt-6 flex flex-col p-4">
                    <h1 className="text-3xl font-bold tracking-wide">Próximos eventos</h1>
                    <h2 className="mb-2 text-zinc-300">Nos vemos pronto</h2>
                </div>
                <EventList events={events} error={error} loading={loading} />
            </div>
        </div>
    );
};

export default Events;
